import {Injectable} from '@angular/core';
import {FieldTable} from '@tj/tj-dmp-lib-api';
import {TargetFieldDestination} from './target-field-destination.interface';

@Injectable({
    providedIn: 'root'
})
export class EtlUpdateDesignService {

    constructor() {
    }

    isDecimalType(field: TargetFieldDestination) {
        return ['Decimal_5_2', 'Decimal_8_2', 'Decimal_11_2'].includes(field?.meta?.type);
    }

    isDateTimeType(destination) {
        const result = (
            destination &&
            destination.meta &&
            (destination.meta.type.includes('Date') ||
                destination.meta.type.includes('Time') || destination.meta.categoryField === 'DAY_NUMBER'
                || destination.meta.categoryField === 'MONTH_NUMBER')
        );
        if (result) {
            destination.pattern = destination.pattern !== undefined ? destination.pattern : '';
        }
        return result;
    }

    getFieldType(destination) {
        if (destination && destination.meta) {
            switch (destination.meta.type) {
                case 'DateTime':
                    return 'date et heure';
                case 'Time':
                    return 'heure';
                case 'Date':
                    return 'date';
            }
        }
    }

    isStringType(destination) {
        const result = (
            destination &&
            destination.meta &&
            (destination.meta.type.includes('String') || destination.meta.type === 'TEXT')
        );
        // init
        if (result) {
            destination.case = destination.case !== undefined ? destination.case : '';
            destination.replace = destination.replace !== undefined ? destination.replace : false;
        }
        return result;
    }

    public getCategory(f: FieldTable) {
        // type
        switch (f.categoryField) {
            case 'TEXT':
                return 'Texte (' + f.type.replace('String', '') + ')';
            case 'CIVILITY':
                return 'Civilité (3)';
            case 'NUMBER':
                return 'Nombre';
            case 'DATE':
                return 'Date';
            case 'DATE_TIME':
                return 'Date et heure';
            case 'TIME':
                return 'heure';
            case 'IATA_CITY':
                return 'Ville (3)';
            case 'IATA_AIRPORT':
                return 'Aéroport (3)';
            case 'IATA_COUNTRY':
                return 'Pays IATA (3)';
            case 'CARRIER':
                return 'Compagnie (3)';
            case 'AFFILIATION':
                return 'Partenaire (3)';
            case 'LANG':
                return 'Langue (2)';
            case 'COUNTRY':
                return 'Pays (3)';
            case 'BOOLEAN':
                return 'Binaire';
            case 'EMAIL':
                return 'Courriel';
            case 'TECHNICAL':
                return 'Techinque';
            case 'PHONE':
            case 'MOBILE':
                return 'Téléphone';
            case 'PRICE':
                return 'Prix';
            case 'BOOKING_REFERENCE' :
                return 'Numéro de commande';
            case 'PRODUCT_TYPE':
                return 'Type de produit';
            default:
                return null;
        }
    }

    public getType(f: FieldTable) {

        switch (f.type) {
            case 'Boolean':
                return 'Binaire';
            case 'Date':
                return 'Date';
            case 'DateTime':
                return 'Date et heure';
            case 'Time':
                return 'Heure';
            case 'Int':
                return 'Nombre entier';
            case 'BigInt':
                return 'Nombre entier (big)';
            case 'Decimal_11_2':
                return 'Nombre décimale (123456789,01)';
            case 'Decimal_5_2':
                return 'Nombre décimale (123,45)';
            case 'Decimal_8_2':
                return 'Nombre décimale (123456,78)';
            case 'String10':
                return 'Texte (10)';
            case 'String100':
                return 'Text (100)';
            case 'String25':
                return 'Texte (25)';
            case 'String255':
                return 'Texte (255)';
            case 'String3':
                return 'Texte (3)';
            case 'String50':
                return 'Texte (50)';
            case 'TEXT':
                return 'Long text';
            case 'UUID':
                return 'UUID';
            default:
                return '?' + f.code;
        }

    }
}
